module.exports = __webpack_public_path__ + "img/home-filled.692e5e70.svg";